import { Component, Injector, Input } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TextMaskConfig } from 'angular2-text-mask';
import { IIrisFormFieldControl } from '@sondermindorg/iris-design-system-angular';
import { BaseControlValueAccessor } from '@sondermind/iris/form-helpers';
// import { IIrisFormFieldControl } from 'iris-form-field-control.interface';
// TODO - replace import to local path once form field feature has been added

@Component({
  selector: 'iris-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: IrisTextInputComponent,
      multi: true
    }
  ]
})
export class IrisTextInputComponent
  extends BaseControlValueAccessor
  implements IIrisFormFieldControl {
  @Input() placeholder: string = '';
  @Input() autocomplete: string = '';
  @Input() isReadonly: boolean = false;
  @Input() type: string = 'text';
  @Input() mask: TextMaskConfig = null;
  @Input() maxLength: string = null;

  constructor(injector: Injector) {
    super(injector);
  }

  get control(): FormControl {
    return this.formControl || this.controlContainer.control.get(this.formControlName) as FormControl;
  }
}
